const setupMap = () => {
  const mapEl = document.getElementById('office-location-map')

  if (!mapEl) {
    return
  }

  const data = JSON.parse(mapEl.dataset.json)

  const mapOptions = {
    center: new google.maps.LatLng(data.lat, data.lng),
    zoom: 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    scrollwheel: false,
    gestureHandling: 'none',
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
    ],
  }

  const map = new google.maps.Map(mapEl, mapOptions)
  const bounds = new google.maps.LatLngBounds()

  google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
    const aiMarker = {
      url: "data:image/svg+xml,%3Csvg viewBox='0 0 39 53' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.034 1.468A19.586 19.586 0 0 1 19.5 0a19.586 19.586 0 0 1 7.466 1.468c2.367.973 4.518 2.4 6.33 4.2a19.343 19.343 0 0 1 4.226 6.288A19.242 19.242 0 0 1 39 19.375C39 34.332 19.5 53 19.5 53S0 34.391 0 19.374c-.003-2.545.5-5.065 1.478-7.417a19.343 19.343 0 0 1 4.226-6.29 19.485 19.485 0 0 1 6.33-4.199Z' fill='%23005288'/%3E%3Cpath d='m18.325 22.197 2.9.002 2.897-.002-1.446 2.46-1.451 2.45-1.447-2.447-1.453-2.463Z' fill='%23fff'/%3E%3Cpath d='m12.528 22.197 2.9.002 2.897-.002-1.446 2.46-1.451 2.45-1.447-2.447-1.453-2.463Z' fill='%23fff'/%3E%3Cpath d='m7.146 22.197 2.898.002 2.899-.002-1.448 2.46-1.45 2.45-1.447-2.447-1.452-2.463ZM15.427 17.287l2.899.003 2.898-.003-1.447 2.46-1.451 2.45-1.447-2.446-1.452-2.464Z' fill='%23fff'/%3E%3Cpath d='m10.044 17.287 2.9.003 2.897-.003-1.447 2.46-1.45 2.45-1.447-2.446-1.453-2.464Z' fill='%23fff'/%3E%3Cpath d='m12.528 12.786 2.9.003 2.897-.003-1.446 2.462-1.451 2.448-1.447-2.446-1.453-2.464ZM23.957 12.786h-5.632l8.447 14.321h5.631l-8.446-14.321Z' fill='%23fff'/%3E%3Cpath d='m15.427 7.876 2.899.003 2.898-.003-1.447 2.461-1.451 2.449-1.447-2.447-1.452-2.463Z' fill='%23fff'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M32.9 26.487c.166.382.55.627.97.62.272 0 .533-.107.724-.299a1 1 0 0 0 .294-.72 1.023 1.023 0 0 0-.64-.95 1.044 1.044 0 0 0-1.132.228c-.296.296-.38.739-.215 1.12Zm.09-.785a.912.912 0 0 1 .88-.514.89.89 0 0 1 .853.9.9.9 0 0 1-.577.834.918.918 0 0 1-.997-.222.891.891 0 0 1-.16-.998Zm.391-.175h.531c.176 0 .345.083.345.268a.325.325 0 0 1-.237.312l.17.234c.066.092.143.177.228.252v.023h-.192c-.064 0-.119-.09-.205-.233a4.706 4.706 0 0 0-.157-.247h-.145v.287c0 .06 0 .092.015.11.017.02.054.025.13.034v.043h-.485v-.043c.076-.008.112-.012.13-.032.015-.019.015-.05.015-.112v-.767c0-.07-.061-.079-.12-.088a.896.896 0 0 1-.026-.004l.003-.037Zm.469.553h-.13l.002-.497h.122c.117 0 .213.072.213.228 0 .157-.062.269-.207.269Z' fill='%23fff'/%3E%3C/svg%3E",
      scaledSize: new google.maps.Size(39, 53),
    }
    const marker = new google.maps.Marker({
      map: map,
      title: data.title,
      animation: google.maps.Animation.DROP,
      position: new google.maps.LatLng(data.lat, data.lng),
      panposition: new google.maps.LatLng(data.lat, data.lng),
      icon: aiMarker,
    })

    google.maps.event.addListener(marker, 'click', () => {
      window.open(data.url, '_blank')
    })

    google.maps.event.addListener(marker, 'mouseover', function () {
      this.setAnimation(google.maps.Animation.BOUNCE)
    })

    google.maps.event.addListener(marker, 'mouseout', function () {
      this.setAnimation(null)
    })

    bounds.extend(marker.getPosition())
  })
}

setupMap()
